<template>
  <div class="login">
    <div class="account-header">
      <div class="header-box">
        <div class="header-logo">
          <a href="/">
            <!-- <img src="../assets/logo.png" /> -->
          </a>
        </div>
      </div>
    </div>
    <div class="account-body">
      <div class="account-box">
        <div class="account-img">
          <div class="img">
            <img src="../assets/account.png">
          </div>
        </div>
        <div class="account-wrapper">
          <div class="account-tab"><span>手机号登录</span>
          </div>
          <div class="account-error">
          </div>
          <el-form ref="form" :model="form" :rules="rules" class="account-form">
            <el-form-item prop="phone">
              <el-input v-model="form.phone" placeholder="请输入手机号">
                <template slot="prepend"><i class="el-icon-mobile-phone"></i></template>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="form.password" placeholder="请输入密码" show-password>
                <template slot="prepend"><i class="el-icon-lock"></i></template>
              </el-input>
            </el-form-item>
            <!-- <div class="form-item">
              <el-input v-model="form.verifycode" placeholder="请输入验证码">
                <template slot="prepend"><i class="el-icon-key"></i></template>
                <div slot="append" class="captcha_code">
                  <img :src="verifyimg" ref="code" @click="changeCode">
                </div>
              </el-input>
            </div> -->
            <div class="form-item clearfix" style="text-align: right;">
              <a href="javascript:;" class="fr"
                style="color: rgb(255, 106, 0); text-decoration: none; cursor: default;">忘记密码请联系老师</a>
            </div>
            <div class="form-item"><button type="button" class="submit-btn" @click="onSubmit" :disabled="logindis">登录</button></div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    login
  } from "../api/api";
  export default {
    name: 'Login',
    data() {
      return {
        accountBg: require('../assets/account.png'),
        form: {
          phone: '',
          password: '',
          // verifycode: ''
        },
        rules: {
          phone: [{
            required: true,
            message: '请输入手机号',
            trigger: 'change'
          }],
          password: [{
            required: true,
            message: '请输入密码',
            trigger: 'change'
          }]
        },
        verifyimg: require('../assets/getCode.jpg'),
        logindis: false
      }
    },
    methods: {
      // changeCode() {
      //   console.log('code')
      // },

      onSubmit() {
        var that = this;
        this.$refs.form.validate((valid) => {
          if (valid) {
            that.logindis = true
            login({
              phone: this.form.phone,
              password: this.form.password
            }).then(res => {
              console.log(res)
              that.logindis = false
              if (res.code == 1) {
                that.$store.dispatch("logined", {
                  jwt_token: res.data.jwt_token,
                  uname: res.data.uname,
                  tiku: res.data.tiku
                });
                that.$Message.info('登陆成功');
                setTimeout(function(){
                  that.$router.push({ name: 'Member' })
                }, 1500)
              } else {
                that.$Message.info({
                  content: res.message,
                  type: 'error'
                })
              }
            })
          }else{
            return false;
          }
        });

      }
    }
  }
</script>

<style>
  .account-header {
    width: 100%;
    background: #fff;
    z-index: 200
  }

  .account-header .header-box {
    width: 1200px;
    margin: 0 auto;
    display: flex
  }

  .account-header .header-box .header-logo {
    width: 250px;
    height: 50px;
    margin: 15px 0;
    overflow: hidden
  }

  .account-header .header-box .header-logo img {
    max-height: 50px;
    max-width: 250px
  }

  .account-body {
    width: 100%;
    height: 720px;
    background: url(../assets/account-bg.png) #001351 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 100
  }

  .account-body .account-box {
    width: 1060px;
    height: 450px;
    display: flex;
    border-radius: 10px;
    box-shadow: 0 0 5px rgba(0, 0, 0, .6);
    overflow: hidden
  }

  .account-body .account-box .account-img {
    width: 670px;
    height: 100%;
    background: hsla(0, 0%, 100%, .4)
  }

  .account-body .account-box .account-img .img {
    width: 100%;
    height: 100%;
    text-align: center;
    line-height: 600px;
  }
  .account-body .account-box .account-img .img img{
    width: 500px;
  }

  .account-body .account-box .account-wrapper {
    width: 390px;
    height: 450px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px 30px
  }

  .account-body .account-box .account-wrapper .account-tab {
    width: 100%;
    height: 30px;
    text-align: center;
  }

  .account-body .account-box .account-wrapper .account-tab.col3 span {
    width: 100%
  }

  .account-body .account-box .account-wrapper .account-tab span {
    display: inline-block;
    vertical-align: middle;
    width: 50%;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    color: #86888b;
    cursor: pointer
  }

  .account-body .account-box .account-wrapper .account-tab span.selected {
    color: #2596fd
  }

  .account-body .account-box .account-wrapper .account-tab span+span {
    border-left: 1px solid #ccc
  }

  .account-body .account-box .account-wrapper .account-error {
    width: 100%;
    height: 30px;
    line-height: 30px;
    color: #ff4500
  }

  .account-body .account-box .account-wrapper .account-error span {
    display: inline-block;
    vertical-align: middle;
    vertical-align: .12em;
    margin-left: 2px
  }

  .account-body .account-box .account-wrapper .account-form {
    width: 100%
  }

  .account-body .account-box .account-wrapper .account-form .form-item+.form-item {
    padding-top: 30px
  }

  .account-body .account-box .account-wrapper .account-form .form-item i {
    color: #d1d2d4;
    line-height: 38px
  }

  .account-body .account-box .account-wrapper .account-form .form-item .ivu-input-suffix .ivu-icon {
    font-size: 24px;
    line-height: 40px
  }

  .account-body .account-box .account-wrapper .account-form .form-item .ivu-input {
    border-radius: 8px
  }

  .account-body .account-box .account-wrapper .account-form .form-item .verify-code {
    width: 100px;
    height: 100%;
    float: right;
    display: flex;
    align-items: center;
    justify-content: center
  }

  .account-body .account-box .account-wrapper .account-form .form-item .phone-code {
    width: 100px;
    height: 38px;
    line-height: 38px;
    float: right;
    margin: 1px 1px 0 0;
    background: #f7f7f7;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    color: #999
  }

  .account-body .account-box .account-wrapper .account-form .form-item .submit-btn {
    width: 100%;
    height: 40px;
    border: none;
    color: #fff;
    background: linear-gradient(90deg, #27a3ff, #2380fb);
    text-align: center;
    border-radius: 8px;
    outline: none;
    cursor: pointer
  }

  .account-body .account-box .account-wrapper .form-reg {
    width: 100%;
    display: inline-block;
    text-align: center;
    margin-top: 20px
  }

  .account-body .account-tips {
    width: 1060px;
    padding: 20px 0
  }

  .account-body .account-tips i {
    color: #eabe14;
    font-size: 20px;
    vertical-align: bottom;
  }

  .account-body .account-tips span {
    display: inline-block;
    vertical-align: middle;
    color: #fff;
    margin-left: 10px
  }

  .account-footer {
    width: 100%;
    padding: 20px 0;
    background: #fff;
    z-index: 200
  }

  .account-footer .footer-box {
    width: 1200px;
    margin: 0 auto;
    display: flex
  }

  .account-footer .footer-box .footer-info {
    display: flex;
    height: 120px;
    padding: 10px
  }

  .account-footer .footer-box .footer-info .info-content {
    line-height: 50px;
    margin-right: 60px
  }

  .account-footer .footer-box .footer-qrcode {
    margin-left: 60px;
    width: 100px
  }

  .account-footer .footer-box .footer-qrcode .qrcode-title {
    text-align: center;
    font-size: 16px;
    color: #666;
    height: 30px;
    line-height: 30px
  }

  .account-footer .footer-box .footer-qrcode .qrcode-img {
    width: 90px;
    margin: 0 auto
  }

  .account-footer .footer-box .footer-qrcode .qrcode-img img {
    width: 90px;
    height: 90px
  }

  .captcha_code {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login.vue